var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcSubtract(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    fill: "none",
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M14 28c7.732 0 14-6.268 14-14S21.732 0 14 0 0 6.268 0 14s6.268 14 14 14zm1.93-13.565c.32.157 1.737.874 3.214 1.968a2.86 2.86 0 0 1 1.157 2.328v.351a.752.752 0 0 1-.752.751H7.751a.752.752 0 0 1-.751-.75v-.352c0-.914.428-1.782 1.162-2.328a21.95 21.95 0 0 1 3.213-1.967.12.12 0 0 0 .069-.11v-1.29a3.077 3.077 0 0 1-.377-1.034c-.143-.011-.334-.214-.54-.94-.283-.99.017-1.136.269-1.113a2.786 2.786 0 0 1-.109-.409c-.088-.462-.114-.894-.006-1.305.129-.551.429-.994.763-1.337.211-.225.451-.422.705-.582.209-.143.437-.266.686-.351.194-.066.402-.109.622-.12.677-.058 1.194.11 1.563.33.554.306.762.71.762.71s1.265.088.837 2.655c-.023.137-.06.272-.108.409.25-.023.548.123.268 1.114-.206.725-.394.928-.54.94a2.905 2.905 0 0 1-.377 1.022v1.302a.12.12 0 0 0 .069.108z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSubtract);
export default __webpack_public_path__ + "static/media/ic_subtract.aa91bc3185a5c0ef11c8c7a20fb86280.svg";
export { ForwardRef as ReactComponent };